import React from 'react';
import { ClockIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function SceneHistory() {
  const history = [{
    id: 1,
    scene: 'Sleep',
    timestamp: '2024-01-15 22:00:00',
    status: 'success',
    actions: ['IR AC Pod set to 24°C', 'Smart Plug - TV turned off', 'Smart Plug - Lights turned off']
  }, {
    id: 2,
    scene: 'Away',
    timestamp: '2024-01-15 08:30:00',
    status: 'success',
    actions: ['Smart Plug - Kitchen turned off', 'Smart Plug - Living Room turned off']
  }, {
    id: 3,
    scene: 'Sleep',
    timestamp: '2024-01-14 22:00:00',
    status: 'success',
    actions: ['IR AC Pod set to 24°C', 'Smart Plug - TV turned off', 'Smart Plug - Lights turned off']
  }, {
    id: 4,
    scene: 'Energy Saving',
    timestamp: '2024-01-14 12:00:00',
    status: 'failed',
    actions: ['IR AC Pod set to 28°C', 'Smart Plug - Kitchen turned off'],
    error: 'IR AC Pod did not respond'
  }];
  return <div className="bg-white rounded-xl shadow-sm" data-id="element-329">
      <div className="p-6 border-b border-gray-200" data-id="element-330">
        <h2 className="text-lg font-semibold" data-id="element-331">Scene Activation History</h2>
        <p className="text-sm text-gray-500" data-id="element-332">
          View all scene activations and their results
        </p>
      </div>
      <div className="divide-y divide-gray-100" data-id="element-333">
        {history.map(item => <div key={item.id} className="p-6 hover:bg-gray-50" data-id="element-334">
            <div className="flex items-start justify-between mb-3" data-id="element-335">
              <div className="flex items-start gap-3" data-id="element-336">
                <div className={`p-2 rounded-full ${item.status === 'success' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-337">
                  {item.status === 'success' ? <CheckCircleIcon size={20} className="text-green-600" data-id="element-338" /> : <XCircleIcon size={20} className="text-red-600" data-id="element-339" />}
                </div>
                <div data-id="element-340">
                  <h3 className="font-medium text-gray-800" data-id="element-341">{item.scene}</h3>
                  <div className="flex items-center text-sm text-gray-500 mt-1" data-id="element-342">
                    <ClockIcon size={14} className="mr-1" data-id="element-343" />
                    {new Date(item.timestamp).toLocaleString()}
                  </div>
                </div>
              </div>
              <span className={`px-2 py-1 rounded text-xs font-medium ${item.status === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`} data-id="element-344">
                {item.status}
              </span>
            </div>
            <div className="ml-11" data-id="element-345">
              <p className="text-sm font-medium text-gray-700 mb-2" data-id="element-346">Actions:</p>
              <ul className="space-y-1" data-id="element-347">
                {item.actions.map((action, index) => <li key={index} className="text-sm text-gray-600" data-id="element-348">
                    • {action}
                  </li>)}
              </ul>
              {item.error && <p className="text-sm text-red-600 mt-2" data-id="element-349">Error: {item.error}</p>}
            </div>
          </div>)}
      </div>
    </div>;
}